import React from 'react'
import ReactDOM from 'react-dom/client'
import { Routes } from '@generouted/react-router'
import '@/utils/translations'
import '@/index.css'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const queryClient = new QueryClient(
  {
    defaultOptions: {
      queries: {
        // Disabling automatic refetching on window focus
        refetchOnWindowFocus: false,
      },
    },
  }
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <Routes />
    </React.StrictMode>
  </QueryClientProvider>
)
